import { useState, useRef, useEffect } from 'react';
import playerImage from '../../assets/images/PlayerImage.png';
import PlayerListContainer from '../../components/PlayerListContainer.js';
import CustomButton from '../../components/CustomButton.js';
import Layout from '../../layouts/Layout.js';
import { useLocation, useNavigate } from 'react-router-dom';
import { endpoint } from '../../assets/api/endpoint.js';
import { useSelector } from 'react-redux';
import { apiHandler } from '../../assets/api/index.js';
import { toast } from 'react-toastify';
import { IoIosArrowDropleft } from "react-icons/io";
import { IoMdSearch } from "react-icons/io";
import FilterImg from '../../assets/icons/Filter.png';
import FilterPage from '../filterpage/FIlterPage.js';
import GameSearchFilter from '../gamesearchfilter/GameSearchFilter.js';

const InvitePlayerList = () => {
    const [players, setPlayers] = useState([]);
    const [searchQuery, setSearchQuery] = useState('');
    const [isSearchVisible, setIsSearchVisible] = useState(false);
    const searchRef = useRef(null);
    const location = useLocation();
    const { invitePlayerList, IsExclude ,playerGameProfileIds} = location?.state || {};
    const { accessToken } = useSelector((state) => state.loginInfo);
    const navigate = useNavigate();
    const [inviteplayerList, setInvitePlayerList] = useState(invitePlayerList);
    const [isOpen, setIsOpen] = useState(false);
    const modalRef = useRef(null);
    const [closeFilter, setCloseFilter] = useState(true)
    const [sportName, setSportName] = useState("");

    useEffect(() => {
        if (inviteplayerList) {
            const mappedPlayers = inviteplayerList.map((player) => ({
                id: player.id,
                name: player.name,
                age: player.age || 'N/A',
                skill: player.skillLevel || 'Unknown',
                sports: player.sport || '',
                distance: player.distance || '0 km away',
                image: player.avatarUrl || playerImage,
                reliability: player.reliability,
                avatarName: player.avatarName,
                gender: player.gender,
                sport: player.sport
            }));
            setPlayers(mappedPlayers);
        }
    }, [inviteplayerList]);

    useEffect(() => {
        const fetchData = async () => {
            const url = IsExclude
                ? `${endpoint.GET_INVITE_EXCLUSION_LIST}?sportId=${playerGameProfileIds}`
                : `${endpoint.GET_INVITE_INCLUSION_LIST}?sportId=${playerGameProfileIds}`;
            try {
                const result = await apiHandler({
                    url,
                    authToken: accessToken.accessToken,
                });
                if (result.data) {
                    setInvitePlayerList(result?.data);

                } else {

                }
            } catch (error) {
                console.error('Error fetching invite list:', error);
            }
        };
        fetchData();
    }, [closeFilter])


    const handleMoveToInclusionList = async (userId) => {
        try {
            const result = await apiHandler({
                url: `${endpoint.MOVE_INTO_EXCLUSION_LIST}?userId=${userId}&sportId=1`,
                method: 'POST',
                authToken: accessToken.accessToken,
            });
            if (result.data && result.data.code != 500) {
                // addFetchFavourite()
                addFetchExclude()
                toast.success('User moved to exclusion list successfully!');
            }
            else {
                toast.error(result?.data?.error_description);
            }
        } catch (error) {
            console.error('Error moving to inclusion list:', error);
        }
    };

    const handleMoveToExclusionList = async (userId) => {
        try {
            const result = await apiHandler({
                url: `${endpoint.MOVE_IN_PREFERABLE_LIST}?userId=${userId}&sportId=1`,
                method: 'POST',
                authToken: accessToken.accessToken,
            });
            if (result.data && result.data.code != 500) {
                addFetchFavourite()
                toast.success('User moved to exclusion list successfully!');
            }
            else {
                toast.error(result?.data?.error_description);
            }
        } catch (error) {
            console.error('Error moving to exclusion list:', error);
        }
    };
    const addFetchFavourite = async () => {
        try {
            const result = await apiHandler({
                url: `${endpoint.GET_INVITE_INCLUSION_LIST}?sportId=1`,
                authToken: accessToken.accessToken,
            });
            setInvitePlayerList(result?.data);
        } catch (error) {
            console.error('Error fetching favorite list:', error);
        }
    }
    const addFetchExclude = async () => {
        try {
            const result = await apiHandler({
                url: `${endpoint.GET_INVITE_EXCLUSION_LIST}?sportId=1`,
                authToken: accessToken.accessToken,
            });
            setInvitePlayerList(result?.data);
        } catch (error) {
            console.error('Error fetching favorite list:', error);
        }
    }
    const onGoToBackPage = () => {
        navigate(-1)
    }

    const handleAdd = (id) => {
        IsExclude && handleMoveToInclusionList(id);
        !IsExclude && handleMoveToExclusionList(id);
    };

    const toggleModal = () => {
        setIsOpen(!isOpen);
    };

    const filteredPlayers = players.filter((player) =>
        player.name.toLowerCase().includes(searchQuery.toLowerCase())
    );
    const handleClickOutside = (event) => {
        if (modalRef.current && !modalRef.current.contains(event.target)) {
            toggleModal();
        }
    };

    useEffect(() => {
        if (isOpen) {
            document.addEventListener("mousedown", handleClickOutside);
        } else {
            document.removeEventListener("mousedown", handleClickOutside);
        }

        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [isOpen]);
    
    const closeModal = () => {
        setCloseFilter(!closeFilter);
    }
    const onCloseFilterModal = (data) => {
        setIsOpen(!data);
        closeModal(data);
    }
    const onCloseModal = () => {
        setIsOpen(false);
    }
    const onSelectedSport = (sportName) => {
        setSportName(sportName)
    }

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (searchRef.current && !searchRef.current.contains(event.target)) {
                setIsSearchVisible(false);
            }
        };

        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [isOpen]);

    return (
        <Layout>
            <div className='profile-invite-content-wrapper p-3 p-sm-4'>
                <div className="d-flex justify-content-between profile-invite-back-wrapper" >
                    <CustomButton
                        className="back-page-btn"
                        onClick={onGoToBackPage}
                        buttonText={
                            <> <IoIosArrowDropleft className="me-3" style={{ cursor: 'pointer', fontSize: '31px' }} /> Back</>
                        }
                    />
                    <h3 className="text-center mb-4 edit-profile-txt fs-3">{IsExclude ? 'Add to  Exclude' : '  Add to Favorite'}</h3>
                    <div className='d-flex w-25 justify-content-between'>
                        <div className="search-bar d-flex justify-content-end h-75">
                            <IoMdSearch className="fs-2 me-2" />
                            <input
                                type="text"
                                placeholder="Search Players..."
                                className="search-input"
                                value={searchQuery}
                                onChange={(e) => setSearchQuery(e.target.value)}
                            />
                        </div>
                        <div>
                            <img src={FilterImg} onClick={toggleModal} style={{ cursor: 'pointer' }} />
                        </div>
                    </div>
                </div>

                <div className="row m-1" style={{ rowGap: '25px' }}>
                    {filteredPlayers.map((player) => (
                        <div className='col-lg-4'>
                            <PlayerListContainer key={player.id}
                                player={{
                                    name: player.name,
                                    age: player.age,
                                    skill: player.skill,
                                    sports: player.sports,
                                    distance: player.distance,
                                    image: player.image,
                                    reliability: player.reliability,
                                    avatarName: player.avatarName,
                                    gender: player.gender,
                                    sport: player.sport
                                }}
                                CustomButton={() => (
                                    <CustomButton
                                        className="Invite-add-button"
                                        onClick={() => handleAdd(player.id)}
                                        buttonText="Add"
                                    />
                                )}
                            />
                        </div>
                    ))}
                    {filteredPlayers.length === 0 && (
                        <p className="text-center mt-3">No players found.</p>
                    )}
                </div>
                {isOpen &&
                    <div className={`modal-overlay ${isOpen ? "open" : "closeModal"}`}>
                        <div ref={modalRef} className="modal-content overflow-x-auto">
                            <GameSearchFilter
                                onCloseFilterModal={onCloseFilterModal}
                                onCloseModal={onCloseModal}
                                onSelectedSport={onSelectedSport}
                                notShowfilterBySport={true}
                            />
                        </div>
                    </div>}
            </div>
        </Layout>
    );
};

export default InvitePlayerList;
